import { generateEntityCrudReducer } from 'syft-acp-util/store/reducers'
import { CommissionsSalesEntity } from './types'
import csatAgencyTypes from './action-types'

export default generateEntityCrudReducer<CommissionsSalesEntity>({
  name: 'commissionsSales',
  actions: csatAgencyTypes,
})
